const localStorageKey = (type) => `application[${type}]`;

function getLocalSave(type) {
  return JSON.parse(localStorage.getItem(localStorageKey(type))) || null;
}

export default {
  namespaced: true,
  state: {
    "right-of-occupancy": getLocalSave("right-of-occupancy"),
    "owner-occupancy": getLocalSave("owner-occupancy"),
    rental: getLocalSave("rental"),
  },
  mutations: {
    store(state, { type, localSave }) {
      state[type] = localSave;
      localStorage.setItem(localStorageKey(type), JSON.stringify(state[type]));
    },
    remove(state, { type }) {
      state[type] = null;
      localStorage.removeItem(localStorageKey(type));
    },
  },
};
